import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputRightElement, InputRightAddon, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure,
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdSettings, MdAdd, MdAddCircleOutline, MdCalendarToday, MdSearch, MdEdit, MdDeleteForever, MdSave } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { withNamespaces } from 'react-i18next';
import { FormattedDate, FormattedTime } from 'react-intl';
import { sortBy } from 'lodash';

import { SUCCESS_STATUS, FAILED_STATUS } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListDoctor, apiLoadADoctor, apiCreateNewDoctor, apiUpdateADoctor, apiDeleteADoctor
} from '../../../redux/apis/DoctorApis';
import { apiLoadASystemSettingByCompanyId } from '../../../redux/apis/SystemSettingApis';
import { clearADoctorDetail, clearDoctorActionStatus } from '../../../redux/actions';
import { getDoctorList, getADoctor, getDoctorActionStatus, getDoctorActionMsg, getDoctorError, getASystemSetting } from '../../../redux/selectors';

import NoDataPage from '../../../components/NoData';
import AddEditDoctorModal from '../Modals/AddEditDoctorModal';

function Doctors({ 
    doctorList, doctorDetail, actionStatus, actionMsg, error, systemSettingDetail, clearADoctorDetail, clearDoctorActionStatus,
    apiLoadListDoctor, apiLoadADoctor, apiCreateNewDoctor, apiUpdateADoctor, apiDeleteADoctor, apiLoadASystemSettingByCompanyId, t
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    const mounted = useRef();

    const [ searchText, setSearchText ] = useState("");
    const [ isSearching, setIsSearching ] = useState(false);
    const [ isAction, setIsAction ] = useState(false);

    useEffect(() => {
        if(!mounted.current) {
            apiLoadListDoctor({ company_id: cookies?.loginCookie?.data?.company_id });
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                if(isOpen) {
                    onClose();
                }
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearDoctorActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearDoctorActionStatus();
            }
        }
    });

    useEffect(() => {
        setIsSearching(false);
    }, [doctorList]);

    const handleAddNewDoctor = () => {
        clearADoctorDetail();
        onOpen();
    }

    const handleUpdateADoctor = (doctor_id) => {
        apiLoadADoctor({ id: doctor_id });
    }

    const handleDeleteADoctor = (doctor_id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>
                            Xác nhận <br />Bạn có muốn xoá bác sỹ này không?
                        </h1>
                        <div>
                            <button onClick={onClose}>Huỷ</button>
                            <button
                                onClick={() => {
                                    apiDeleteADoctor({ 
                                        id: doctor_id, 
                                        payload: { 
                                            company_id: cookies?.loginCookie?.data?.company_id,  
                                            user_id: cookies?.loginCookie?.data?.id,  
                                            is_active: false 
                                        } 
                                    });
                                    onClose();
                                }}
                                className='yes'
                            >
                                Đồng Ý
                            </button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        })
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" px={4} py={2} gap={2} justify="space-between">
                <Button colorScheme='orange' isDisabled={!isAction} onClick={handleAddNewDoctor}>
                    <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                    <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                </Button>

                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}}>
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);
                            setTimeout(() => {
                                apiLoadListDoctor({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    apiLoadListDoctor({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>
            
            <PaginatedItems items={doctorList} itemsPerPage={10} onOpen={onOpen} isAction={isAction} t={t}
                handleUpdateADoctor={handleUpdateADoctor} handleDeleteADoctor={handleDeleteADoctor} 
            />

            {
                !(doctorList && doctorList.length > 0) &&
                <NoDataPage  text="Hiện tại không có dữ liệu"/>
            }  
            {
                isOpen &&
                <AddEditDoctorModal 
                    initialRef={initialRef} isOpen={isOpen} onClose={onClose} company_id={cookies?.loginCookie?.data?.company_id} 
                    doctorList={doctorList} doctorDetail={doctorDetail} systemSettingDetail={systemSettingDetail} actionStatus={actionStatus}
                    apiCreateNewDoctor={apiCreateNewDoctor} apiUpdateADoctor={apiUpdateADoctor} 
                    apiLoadASystemSettingByCompanyId={apiLoadASystemSettingByCompanyId}
                />
            }
            <ToastContainer />
        </React.Fragment>
    )
}

function PaginatedItems({ items, itemsPerPage, onOpen, isAction, handleUpdateADoctor, handleDeleteADoctor, t }) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    } 

    return (
        <>
           <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0" textTransform="uppercase">
                            <Th>{t("Index")}</Th>  
                            <Th>{t("Full_Name")}</Th>    
                            <Th>{t("Portrait")}</Th>
                            <Th>{t("Specialist")}</Th>
                            <Th>{t("Phone")}</Th>
                            <Th>{t("Address")}</Th>
                            <Th>{t("Education")}</Th>
                            <Th>{t("Working_Daily")}</Th>
                            <Th>{t("Working_Hourly")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            currentItems && currentItems.map((item, idx) => {
                                let workDailyText = "";

                                if(item.work_daily) {
                                    const work_daily_sortBy = sortBy(item.work_daily, ["label"]);
                                    work_daily_sortBy.map(doc => {
                                        workDailyText += workDailyText.length === 0 ? doc.label : ", " + doc.label;
                                    })
                                }

                                return (
                                    <Tr key={item.id}>
                                        <Td>
                                            <Text fontWeight="600">{itemOffset + idx + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.name}</Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.portrait_url &&
                                                <Image alt="doctor portrait" 
                                                    src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/doctors/${item.portrait_url}`} 
                                                    width="50px" height="50px"
                                                />
                                            }
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600" color="red">{item.specialist}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.phone}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.address}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.education}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{workDailyText}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{`${item.from_time} - ${item.to_time}`}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                            </Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={1}>
                                                <IconButton
                                                    colorScheme='blackAlpha'
                                                    title='Sửa'
                                                    icon={<MdEdit />}
                                                    isDisabled={!isAction}
                                                    onClick={() => {
                                                            onOpen();
                                                            handleUpdateADoctor(item.id);
                                                        }
                                                    }
                                                />
                                                <IconButton
                                                    colorScheme='red'
                                                    title='Xoá'
                                                    icon={<MdDeleteForever />}
                                                    isDisabled={!isAction}
                                                    onClick={() => handleDeleteADoctor(item.id)}
                                                />
                                            </Flex>
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>

            {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
        </>
    )
}

const mapStateToProps = (state) => {
    const doctorList           =   getDoctorList(state);
    const doctorDetail         =   getADoctor(state);
    const actionStatus         =   getDoctorActionStatus(state);
    const actionMsg            =   getDoctorActionMsg(state);
    const error                =   getDoctorError(state);
    const systemSettingDetail  =   getASystemSetting(state);

    return { doctorList, doctorDetail, actionStatus, actionMsg, error, systemSettingDetail };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListDoctor:        payload => dispatch(apiLoadListDoctor(payload)),
    apiLoadADoctor:           payload => dispatch(apiLoadADoctor(payload)),
    apiCreateNewDoctor:       payload => dispatch(apiCreateNewDoctor(payload)),
    apiUpdateADoctor:         payload => dispatch(apiUpdateADoctor(payload)),
    apiDeleteADoctor:         payload => dispatch(apiDeleteADoctor(payload)),
    apiLoadASystemSettingByCompanyId:  payload => dispatch(apiLoadASystemSettingByCompanyId(payload)),

    clearADoctorDetail:             payload => dispatch(clearADoctorDetail(payload)),
    clearDoctorActionStatus:        payload => dispatch(clearDoctorActionStatus(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Doctors));